import { render } from "./AuthenticationCard.vue?vue&type=template&id=6f47ad0a"
const script = {}

import exportComponent from "/Users/saleem/Sites/unitedtours/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__